import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
config: any;
footerMenu: any;
socialMenu: any;
  constructor(
  		private router: Router,
  		private appComponent: AppComponent
  	){
  		this.config = this.appComponent.config;
  		this.footerMenu = this.appComponent.config.footerMenu;
  		this.socialMenu = this.appComponent.config.socialMenu;
  }

  ngOnInit(): void {
  }

  scrollToLink(href){
  	if(this.router.url == "/home" && href != "/login" && href != "/register" && href != "/terms-conditions") {

  		 $([document.documentElement, document.body]).animate({
		        scrollTop: $(href).offset().top
		    }, 1000);
  	} else {
  		  	if (href == "/login" || href == "/register" || href == "/terms-conditions"){
  		  		this.router.navigate([href]);
  		  	} else {
  		  		  		this.router.navigate(['/home']);
  		  		  		setTimeout(function(){
  		  		  			$([document.documentElement, document.body]).animate({
  		  				        scrollTop: $(href).offset().top
  		  				    }, 1000);
  		  		  		}, 100);
  		  	}
  	}


  	
   
  }
}
